export default "__VITE_ASSET__06722b68__"